import {generateRouteHref} from 'epic-fortnite-react';
import PropTypes from 'prop-types';
import React from 'react';
import {useLocation} from 'react-router';

function VideoRecapHeader({data, mobile, tablet, getMessage}) {
  const location = useLocation();
  const {title, subtitle, background, ctaText, ctaLink} = data;
  const isMobile = mobile || tablet;

  let bkImage = '';
  if (background) {
    bkImage = isMobile ? background.tabletImage : background.desktopImage;
  }
  const headerBg = {backgroundImage: `url(${bkImage})`};

  return (
    <section className="cvrv header">
      <div className="backgroundWrapper">
        <div className="backgroundContainer">
          <div className="backgroundImage" style={headerBg} />
        </div>
      </div>
      <div className="cvrv-container">
        <div className="cvrv-heading">
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
        <div className="cvrv-content">
          <button className="cvrv-btn">
            {getMessage('epic.fortnite.idomoo.video.createMyOwn')}
          </button>

          <a
            href={generateRouteHref(ctaLink, location)}
            className="cvrv-btn diagonal inverted blue">
            <span>{ctaText || getMessage('epic.fortnite.idomoo.video.createByEpic')}</span>
          </a>
        </div>
      </div>
    </section>
  );
}

VideoRecapHeader.propTypes = {
  data: PropTypes.object.isRequired,
  mobile: PropTypes.bool,
  tablet: PropTypes.bool,
  getMessage: PropTypes.func,
};
export default VideoRecapHeader;
